import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Log API
 */
class LogApi extends ApiBase {
  async sendClientlogs(payload) {
    const request = {
      url: `${this.API_URL}/jslogs`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(payload)
    };

    const response = await axios.request(request);
    return response.status;
  }
}

export default new LogApi();
